module.exports = __webpack_public_path__ + "img/step38_a_lift_the_stacker.897d830b.png";